/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAdminBenutzerListResponseDto } from '../../models/lexplus-admin-benutzer-list-response-dto';

export interface AdminBenutzerverwaltungControllerFindAllPaginatedV1$Params {

/**
 * Page number to retrieve. If you provide invalid value the default page number will applied
 *
 * **Example:** 1
 *
 *
 * **Default Value:** 1
 */
  page?: number;

/**
 * Number of records per page.
 *
 *
 * **Example:** 20
 *
 *
 *
 * **Default Value:** 25
 *
 *
 *
 * **Max Value:** 100
 *
 *
 * If provided value is greater than max value, max value will be applied.
 */
  limit?: number;

/**
 * Filter by lockoutEndDateUtc query param.
 *
 * **Format:** filter.lockoutEndDateUtc={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.lockoutEndDateUtc=$null:John Doe
 *
 * **Available Operations**
 * - $null
 *
 * - $and
 *
 * - $or
 */
  'filter.lockoutEndDateUtc'?: Array<string>;

/**
 * Filter by kundeID query param.
 *
 * **Format:** filter.kundeID={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.kundeID=$eq:John Doe&filter.kundeID=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $and
 *
 * - $or
 */
  'filter.kundeID'?: Array<string>;

/**
 * Filter by istNeosysAdmin query param.
 *
 * **Format:** filter.istNeosysAdmin={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.istNeosysAdmin=$eq:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $and
 *
 * - $or
 */
  'filter.istNeosysAdmin'?: Array<string>;

/**
 * Filter by istKundeAdmin query param.
 *
 * **Format:** filter.istKundeAdmin={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.istKundeAdmin=$eq:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $and
 *
 * - $or
 */
  'filter.istKundeAdmin'?: Array<string>;

/**
 * Parameter to sort by.
 * To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting
 *
 * **Format:** {fieldName}:{DIRECTION}
 *
 *
 * **Example:** sortBy=nachname:DESC&sortBy=vorname:DESC
 *
 *
 * **Default Value:** nachname:ASC
 *
 * **Available Fields**
 * - nachname
 *
 * - vorname
 *
 * - email
 *
 * - kundeKunde.name
 *
 * - spracheSprache.lokalisierung
 *
 * - newsletterAktiv
 */
  sortBy?: Array<'nachname:ASC' | 'nachname:DESC' | 'vorname:ASC' | 'vorname:DESC' | 'email:ASC' | 'email:DESC' | 'kundeKunde.name:ASC' | 'kundeKunde.name:DESC' | 'spracheSprache.lokalisierung:ASC' | 'spracheSprache.lokalisierung:DESC' | 'newsletterAktiv:ASC' | 'newsletterAktiv:DESC'>;

/**
 * Search term to filter result values
 *
 * **Example:** John
 *
 *
 * **Default Value:** No default value
 */
  search?: string;

/**
 * List of fields to search by term to filter result values
 *
 * **Example:** vorname,nachname,email,emailOriginal
 *
 *
 * **Default Value:** By default all fields mentioned below will be used to search by term
 *
 * **Available Fields**
 * - vorname
 *
 * - nachname
 *
 * - email
 *
 * - emailOriginal
 */
  searchBy?: Array<string>;

/**
 * List of fields to select.
 *
 * **Example:** id,vorname,nachname,email,emailOriginal
 *
 *
 * **Default Value:** By default all fields returns. If you want to select only some fields, provide them in query param
 */
  select?: string;
}

export function adminBenutzerverwaltungControllerFindAllPaginatedV1(http: HttpClient, rootUrl: string, params?: AdminBenutzerverwaltungControllerFindAllPaginatedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusAdminBenutzerListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, adminBenutzerverwaltungControllerFindAllPaginatedV1.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('filter.lockoutEndDateUtc', params['filter.lockoutEndDateUtc'], {});
    rb.query('filter.kundeID', params['filter.kundeID'], {});
    rb.query('filter.istNeosysAdmin', params['filter.istNeosysAdmin'], {});
    rb.query('filter.istKundeAdmin', params['filter.istKundeAdmin'], {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('search', params.search, {});
    rb.query('searchBy', params.searchBy, {});
    rb.query('select', params.select, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusAdminBenutzerListResponseDto>;
    })
  );
}

adminBenutzerverwaltungControllerFindAllPaginatedV1.PATH = '/v1/benutzerverwaltung';
